import React from 'react';

import Template from '@/common/layout/Template';

const PendingVendorApplication = () => {
  return (
    <Template header="">
      <div className="bg-white rounded-sm shadow-xl flex flex-col justify-center items-center p-8 space-y-8">
        <p>Your Vendor Application is currently under review.</p>
        <p>We will notify you when you are granted access to the platform.</p>
      </div>
    </Template>
  );
};

export default PendingVendorApplication;
